import { enhancedTmsApiService } from './enhancements/enhancedTmsApiService'

export const {
  useGetApiProductdataMarketByMarketIdLanguagesQuery: useMarketLanguagesQuery,
  useGetApiProductdataGetvehicletypeidsQuery: useVehicleTypeIdsQuery,
  useGetApiProductdataGetviewheadersByMarketIdQuery: useViewsByMarketIdQuery,
  useGetApiUserdataGetmarketsQuery: useGetMarketsQuery,
  useGetApiProductdataGetconfigurationtypeidsQuery: useGetConfigurationTypeIds,
  useGetApiProductdataMarketByMarketIdPartPeriodFromDesiredDealerDateQuery: usePartPeriodFromDesiredDealerDateQuery,

  // configuration mutations
  usePostApiConfigurationByUuidSelectVariantsMutation: useSelectVariantsMutation,
  usePostApiConfigurationByUuidStepAndStepMutation: useConfigurationStepMutation,
  usePostApiConfigurationMutation: useStartConfigurationMutation,
  usePostApiConfigurationByUuidUndocommitMutation: useUndoVariantSelectMutation,
  usePutApiConfigurationByUuidChangeGroupOfInterestMutation: useCompatibilityCheckMutation,

  // market
  useGetApiAdmintoolMarketsQuery,
  usePutApiAdmintoolMarketsByMarketIdMutation: useUpdateMarketMutation,
  usePostApiAdmintoolMarketsMutation: useCreateMarketMutation,
  useDeleteApiAdmintoolMarketsByMarketIdMutation: useDeleteMarketMutation,

  // reference trucks
  useGetApiAdmintoolMarketsByMarketIdReferenceTrucksQuery,
  useGetApiAdmintoolMarketsByMarketIdReferenceTrucksQuery: useGetReferenceTrucksQuery,
  usePostApiAdmintoolMarketsByMarketIdReferenceTrucksMutation: useCreateReferenceTruckMutation,
  usePutApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdMutation: useUpdateReferenceTruckMutation,
  useDeleteApiAdmintoolMarketsByMarketIdReferenceTrucksAndReferenceTruckIdMutation: useDeleteReferenceTruckMutation,

  // factory code attributes
  usePostApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useCreateFactoryCodeAttributesMutation,
  usePutApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useUpdateFactoryCodeAttributesMutation,
  useDeleteApiAdmintoolMarketsByMarketIdFactoryCodeAttrsAndFactoryCodeItemIdMutation: useDeleteFactoryCodeAttributesMutation,

  // national code groups
  usePostApiAdmintoolMarketsByMarketIdGroupsMutation: useCreateGroupMutation,
  usePutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdMutation: useUpdateGroupMutation,
  useDeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdMutation: useDeleteGroupMutation,

  // national code families
  usePostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesMutation: useCreateFamilyMutation,
  usePutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdMutation: useUpdateFamilyMutation,
  useDeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdMutation: useDeleteFamilyMutation,

  // national code variants
  usePostApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsMutation: useCreateVariantMutation,
  usePutApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdMutation: useUpdateVariantMutation,
  useDeleteApiAdmintoolMarketsByMarketIdGroupsAndGroupIdFamiliesFamilyIdExecutionsExecutionIdMutation: useDeleteVariantMutation,
} = {
  ...enhancedTmsApiService,
}
